import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import billing from "./billing";
import receipt from "./components/receipt";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import invoice from "./components/invoice";
import billingInfo from "./components/billingInfo";

export default [
  {
    path: "/billing",
    component: Dashboard,
    children: [
      {
        path: "billing",
        component: billing,
        children: [
          {
            path: "",
            name: "Billing",
            component: billingInfo,
          },
          {
            path: "receipt/:code",
            name: "Receipt",
            component: receipt,
            meta: { middleware: [Auth] },
          },
          {
            path: "invoice/:code",
            name: "Invoice",
            component: invoice,
            meta: { middleware: [Auth] },
          },
        ],
      },
    ],
  },
];
